import useIsDailyPlanPage from '@/services/plans/hooks/useIsDailyPlanPage';
import { endOfTheWeek, isThisWeek, startOfTheWeek } from '@/utils/calendar';
import { getDateFnsLocale } from '@/utils/dateLocale';
import rem from '@/utils/rem';
import { Box, HStack, Text } from '@chakra-ui/react';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

type Props = {
  selectedDate: Date;
};

const InnerDate = ({ selectedDate }: Props) => {
  const { i18n } = useTranslation();

  // Get the appropriate locale for date-fns based on current language
  const dateLocale = getDateFnsLocale(i18n.language);

  const startDate = selectedDate && format(startOfTheWeek(selectedDate), 'MMM dd', { locale: dateLocale });
  const endDate = selectedDate && format(endOfTheWeek(selectedDate), 'MMM dd', { locale: dateLocale });
  const endDateYear = selectedDate && format(endOfTheWeek(selectedDate), 'yyyy', { locale: dateLocale });
  const isDailyPlanPage = useIsDailyPlanPage();

  const dateLabel = isDailyPlanPage
    ? format(selectedDate, 'EEE, MMM dd', { locale: dateLocale })
    : `${startDate} - ${endDate}`;

  const isCurrentWeek = isThisWeek(startOfTheWeek(selectedDate));

  return (
    <HStack textStyle="h4BarSB" gap={0} minWidth={rem(220)} textTransform="uppercase">
      <Box
        width={rem(6)}
        height={rem(6)}
        marginRight={rem(8)}
        borderRadius={99}
        backgroundColor={isCurrentWeek ? 'cyan.400' : 'gray.400'}
      />
      <Text as="span">{dateLabel}</Text>
      <Text as="span" opacity={0.5}>{`, ${endDateYear}`}</Text>
    </HStack>
  );
};
export default InnerDate;
